import { LoginInputType, LoginTypeWithValue } from './types';
import { emailRegex } from '../utils';
import { isCorrectPhoneNumber } from '../PhoneInput/utils';
import { LoginType } from '@websky/graphql';

const normalizeEmailDomain = (domain: string): string => domain.trim().replace(/^@+/, '').toLowerCase();

export const isEmailDomainBlockedForRegistration = (email: string, blockedDomains?: string[]): boolean => {
	if (!blockedDomains?.length) {
		return false;
	}

	const emailDomain = email.slice(email.lastIndexOf('@') + 1);
	const normalizedEmailDomain = normalizeEmailDomain(emailDomain);

	return blockedDomains.some(blockedDomain => normalizeEmailDomain(blockedDomain) === normalizedEmailDomain);
};

export const detectInputType = (value: string): LoginInputType => {
	if (emailRegex.test(value)) {
		return LoginInputType.Email;
	} else if (isCorrectPhoneNumber(value)) {
		return LoginInputType.Phone;
	} else {
		return LoginInputType.Text;
	}
};

export const getLoginTypeValue = (loginTypes: LoginTypeWithValue[], loginType: LoginType): string => {
	return loginTypes.find(({ type }) => type === loginType)?.value;
};
